import { IModal } from '@app/interfaces/modal';
import { IObservable, ISubject, Subject } from '@app/utils/observable';
import { Template } from '@app/utils/template';
import { MemberCardCheckboxComponent } from './card-checkbox';
import { ICheckboxChangeArgs } from '@app/interfaces/checkbox';
import { toDictionary } from '@app/utils/to-dictionary';

import "jquery-ui";
import 'jquery-ui/ui/widgets/accordion';


export class MemberPickerModalComponent implements IModal {
    private readonly closeEventSubject: ISubject<IModal, any>;
    private readonly memberChangeSubject: ISubject<MemberPickerModalComponent, ICheckboxChangeArgs<number>>;

    private element?: HTMLElement;

    private memberCards: { [key: number]: MemberCardCheckboxComponent; } = {};
    private memberCardIds: number[] = []; // Array of IDs kept alongside map to preserve ordering
    private assemblyIds: number[] = [];
    private maxAssemblyId: number;

    get onClose$(): IObservable<IModal, any> {
        return this.closeEventSubject;
    }

    get onMemberChange$(): IObservable<MemberPickerModalComponent, ICheckboxChangeArgs<number>> {
        return this.memberChangeSubject;
    }

    constructor(memberCards: MemberCardCheckboxComponent[]) {
        this.closeEventSubject = new Subject;
        this.memberChangeSubject = new Subject;

        this.onMemberCardChange = this.onMemberCardChange.bind(this);

        this.memberCardIds = memberCards.map(c => c.id);
        this.memberCards = toDictionary(memberCards, c => c.id);
        
        for (const card of memberCards) {
            if (this.assemblyIds.indexOf(card.assemblyId) === -1 && card.assemblyId !== 0) {
                this.assemblyIds.push(card.assemblyId);
            }
            card.onChange$.subscribe(this.onMemberCardChange);
        }

        this.maxAssemblyId = this.assemblyIds.reduce((prev, current) => prev > current ? prev : current);
    }

    receiveMemberChangeEvent(event: ICheckboxChangeArgs<number>) {
        const id = event.key;
        const card = this.memberCards[id];

        if (card.checked === event.checked) {
            return;
        }

        card.checked = event.checked;
    }

    onMemberCardChange(sender: MemberCardCheckboxComponent, args: ICheckboxChangeArgs<number>) {
        this.memberChangeSubject.emit(this, args);
    }

    shouldCloseModal() {
        return true;
    }

    render(): HTMLElement[] {
        if (this.element) {
            return [this.element];
        }

        const html = Template.getById("member-picker-modal");
        const content = html.querySelector(".modal__content")!;

        const currentAssembly =
            parseInt(content.querySelector("#currentAssemblyMemberLanding")?.getAttribute("data-current-assembly") ?? "0");

        const currentMemberLanding = content.querySelector("#currentAssemblyMemberLanding")!;
        const previousMemberLanding = content.querySelector("#previousAssemblyMemberLanding")!;

        for (let i = 0; i < this.memberCardIds.length; i++) {
            const thisCard = this.memberCards[this.memberCardIds[i]];
            if (thisCard.assemblyId === currentAssembly || thisCard.assemblyId === 0 || currentAssembly === 0) {
                currentMemberLanding.appendChild(thisCard.element);
            } else {
                previousMemberLanding.appendChild(thisCard.element);
            }
        }

        $(content).accordion({
            animate: 200,
            collapsible: true,
            heightStyle: "content",
            active: false
        });

        this.attachButtonEventListeners(html);

        this.element = html;
        
        return [html];
    }

    attachButtonEventListeners(element: HTMLElement) {
        const clearButton = element.querySelector(".member-picker-modal__clear-button") as HTMLElement;
        const okButton = element.querySelector(".member-picker-modal__ok-button") as HTMLElement;

        clearButton.addEventListener("click", ev => {
            for (const id of this.memberCardIds) {
                const card = this.memberCards[id];
                card.checked = false;
            }
        });

        okButton.addEventListener("click", ev => {
            this.closeEventSubject.emit(this, null);
        });
    }
}